import axios from "axios";

// const baseUrl = `http://localhost:7089/`;
//const baseUrl = `https://uvgaming.uvcann.com/`;
 const baseUrl  = 'https://uvgamingservice.uvcannproducts.com/'
 const backendUrl = `https://mtgmoovgaming.uvcannproducts.com/api`;



export const sendOtp = async (data) => {
  return await axios.post(`${backendUrl}/send-otp`, data);
};

export const verifyOtp = async (data) => {
  return axios.post(`${backendUrl}/verify-otp`, data);
};

export const unsubscribe = async (data) => {
  return axios.post(`${backendUrl}/unsubscribe`, data);
};

export const checkUser = async (data) => {
  return axios.post(`${backendUrl}/check-user`, data);
};

export const fetchGamesApi = async (language_id = 1) => {
  const response = await axios.get(
    `${baseUrl}api/games?language_id=${language_id}`,
  );
  return response;
};

export const fetchAndroidGamesApi = async (language_id = 1) => {
  const response = await axios.get(
    `${baseUrl}api/games/android?language_id=${language_id}`,
  );
  return response;
};

export const loginApi = async (msisdn) => {
  const response = await axios.post(`${baseUrl}api/v1/login`, {
    msisdn,
  });
  return response;
};

export const liveLeaderboardApi = async (token) => {
  const response = await axios.get(
    `${baseUrl}api/v1/protected/live-leaderboard`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response;
};

export const winnersLeaderboardApi = async (token) => {
  const response = await axios.get(`${baseUrl}api/v1/protected/winners`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response;
};

export const userProfileApi = async (token) => {
  const response = await axios.get(`${baseUrl}api/v1/protected/user-profile`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response;
};

export const editProfileApi = async (formData, token) => {
  const response = await axios.post(
    `${baseUrl}api/v1/protected/edit-profile`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response;
};




export const SAVE_PLAYTIME_API = `${baseUrl}api/v1/protected/save-play-time`;
